import { useState, useCallback } from "react";
import { message } from "antd";

import { useCaseViewContext } from "../context/CaseViewContext";
import { CaseStatusEnum } from "../constants";

export const useReferrals = () => {
    const [loading, setLoading] = useState(false)
    const [referralCases, setReferralCases] = useState([])
    const [referralCaseCount, setReferralCaseCount] = useState(0)
    const [reviewNotes, setReviewNotes] = useState('')
    const [reviewModalVisible, setReviewModalVisible] = useState(false)

    const {
        caseDetails,
        fetchCaseDetails,
        apiClasses,
    } = useCaseViewContext()

    const getReferralCases = useCallback(async () => {
        try {
            const { data } = await apiClasses?.PhysicianAPI?.getReferralCases()
            const { payload } = data;
            setReferralCaseCount(payload.count)
            setReferralCases(payload.data || [])
            setLoading(false)
        } catch (e) {
            console.log(error);
            message.warning("Unable to retrieve referral cases");
        }
    }, [apiClasses])

    const rejectReview = useCallback(async (reason) => {
        try {
            const { data } = await apiClasses?.PhysicianAPI?.rejectCaseReview({ caseId: caseDetails?._id, reason })
            if (!data.success) throw new Error(data?.message)
            handleFinish()
        } catch (e) {
            message.error(e.message);
        }
    }, [apiClasses, caseDetails])

    const approveReview = useCallback(async () => {
        try {
            const { data } = await apiClasses?.PhysicianAPI?.updateCaseStatus(caseDetails?._id, { status: CaseStatusEnum.CONSULT_COMPLETE_NO_RX, sendToPatient: true })
            if (!data.success) throw new Error(data?.message)
            message.success("Successfully submitted review to assigned physician");
            handleFinish()
        } catch (e) {
            message.error(e.message);
        }
    }, [apiClasses, caseDetails])

    const handleFinish = useCallback(() => {
        getReferralCases()
        setReviewModalVisible(false)
        fetchCaseDetails(caseDetails._id)
    }, [getReferralCases, caseDetails])

    const showReviewModal = () => setReviewModalVisible(true)
    const hideReviewModal = () => setReviewModalVisible(false)

    return {
        loading,
        referralCases,
        referralCaseCount,
        getReferralCases,
        rejectReview,
        approveReview,
        showReviewModal,
        hideReviewModal,
        reviewModalVisible,
        reviewNotes,
        setReviewNotes
    }
}